import React, {useMemo} from 'react'
import {useIntl} from 'react-intl'
import PropTypes from 'prop-types'

// Chakra Components
import {
    Accordion,
    AccordionButton,
    AccordionItem,
    AccordionPanel,
    Box,
    Skeleton,
    Text,
    useStyleConfig
} from '@chakra-ui/react'

import {ArrowIcon} from '../../../../components/icons'

import lazyLoadable from '../../../../utils/lazy-loadable'
import {hasWhatsIncluded} from './utils'

const fallback = <Skeleton height="25vh" width="100%" />

const LazySpecifications = lazyLoadable(() => import('./specifications'), {
    fallback,
    ssr: false
})
const LazyWhatsIncluded = lazyLoadable(() => import('./whats-included'), {
    fallback,
    ssr: false
})

export const SpecificationsAndWhatsIncluded = ({product, ...props}) => {
    const intl = useIntl()
    const styles = useStyleConfig('Specifications', {product})
    const _hasWhatsIncluded = useMemo(() => hasWhatsIncluded(product), [product])

    if (!product) {
        return null
    }

    return (
        <Box {...styles.container} {...props}>
            <Accordion {...styles.accordion} allowMultiple>
                <AccordionItem {...styles.accordionItem}>
                    {({isExpanded}) => (
                        <>
                            <Text as="h3">
                                <AccordionButton {...styles.accordionButton}>
                                    {intl.formatMessage({
                                        id: 'pdp.module.specifications',
                                        defaultMessage: 'Specifications'
                                    })}
                                    <ArrowIcon
                                        boxSize={4}
                                        transform={isExpanded && 'rotate(-180deg)'}
                                        transition=".2s"
                                    />
                                </AccordionButton>
                            </Text>
                            <AccordionPanel {...styles.accordionPanel} mt={8}>
                                <LazySpecifications product={product} />
                            </AccordionPanel>
                        </>
                    )}
                </AccordionItem>

                {_hasWhatsIncluded && (
                    <AccordionItem {...styles.accordionItem} defaultIsOpen={true}>
                        {({isExpanded}) => (
                            <>
                                <Text as="h3">
                                    <AccordionButton {...styles.accordionButton}>
                                        {intl.formatMessage({
                                            id: 'pdp.module.specifications.included',
                                            defaultMessage: "What's included"
                                        })}
                                        <ArrowIcon
                                            boxSize={4}
                                            transform={isExpanded && 'rotate(-180deg)'}
                                            transition=".2s"
                                        />
                                    </AccordionButton>
                                </Text>
                                <AccordionPanel {...styles.accordionPanel} mt={8}>
                                    <LazyWhatsIncluded product={product} />
                                </AccordionPanel>
                            </>
                        )}
                    </AccordionItem>
                )}
            </Accordion>
        </Box>
    )
}

SpecificationsAndWhatsIncluded.propTypes = {
    product: PropTypes.object
}

export default SpecificationsAndWhatsIncluded
